import React from "react";

function Footer(){
    return(
        <div className="text-white font-[Poppins] w-full bg-[black] flex justify-center h-14 items-center mt-24">
            <h1 className="text-sm sm:text-base md:text-lg lg:text-xl font-[500]">Created By Hashir Shaikh Suleman</h1>
        </div>
    );
};

export default Footer;